module.exports = __webpack_public_path__ + "img/ch18_08_辞别博士.c4a6a534.jpg";